import * as collapse from "./collapse";
import * as slider from "./slider";

export namespace Display {
  export const Collapse = collapse.default;
  export const CollapseItem = collapse.Item;
  export const Slider = slider.default;
  export const SliderItem = slider.Item;
}
